import defaults from '../layoutConfig.json';
const { VERTICAL_DEFAULT } = defaults;

const hy = (window as any).hy;

export const layoutTargets = [
  {
    name: 'root',
    layout: hy.LAYOUT_TYPES.STACK,
    direction: hy.LAYOUT_ORIENTATION.VERTICAL,
  },
  {
    name: 'hidden',
    parent: 'root',
    height: 0,
    width: 0,
    _hidden: true,
    _target: true,
  },
  {
    name: 'middle',
    parent: 'root',
    layout: hy.LAYOUT_TYPES.STACK,
    direction: hy.LAYOUT_ORIENTATION.HORIZONTAL,
  },
  {
    name: hy.ANNOTATION_TARGETS.PLAYER,
    parent: 'middle',
    layout: hy.LAYOUT_TYPES.ABSOLUTE,
    aspect: hy.DEFAULT_ASPECT_RATIO * 100,
    physicalWidth: hy.BASE_WIDTH,
    _target: true,
  },
  {
    name: hy.ANNOTATION_TARGETS.ADJACENT_BOTTOM,
    parent: 'root',
    layout: hy.LAYOUT_TYPES.FILL,
    height: VERTICAL_DEFAULT,
    _dimension: 'height',
    _direction: 'bottom',
    _target: true,
  },
];
